"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchFilter = void 0;
var Widget_1 = require("../tools/Widget");
var jquery_1 = __importDefault(require("jquery"));
var PageLoader_1 = require("./PageLoader");
var Collapsible_1 = require("./Collapsible");
var hasPushState = "pushState" in history;
var $doc = (0, jquery_1.default)(document);
var SearchFilter = (function (_super) {
    __extends(SearchFilter, _super);
    function SearchFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchFilter.prototype.defaultConfig = function () {
        return {
            debounceTime: 600
        };
    };
    SearchFilter.prototype.init = function () {
        var _this = this;
        this.el.on("submit", "form.search-filter", function (e) { return _this.handleSubmit(e); });
        this.el.on("change", "form.search-filter :input", function (e) {
            return _this.handleChange(e);
        });
        this.el.on("click", "a.clear-filters", function (e) { return _this.handleClear(e); });
        this.el.on("click", ".search-filter-buttons span.ico-close", function (e) {
            return _this.handleCloseFilterButtonClick(e);
        });
        (0, jquery_1.default)(window).on("popstate", function () { return SearchFilter.handlePopstate(); });
        var firstFilterClearingAnchor = this.el.find(".clear-filters")[0];
        if (firstFilterClearingAnchor) {
            this.initialStateUrl = firstFilterClearingAnchor.href;
            this.initialStatePath = firstFilterClearingAnchor.getAttribute("href");
        }
        if (location.href == this.initialStateUrl) {
            this.initialState = SearchFilter.getState(document.body.innerHTML, location.href);
        }
    };
    SearchFilter.prototype.handleCloseFilterButtonClick = function (event) {
        console.log(event);
    };
    SearchFilter.prototype.handleSubmit = function (event) {
        if (!hasPushState) {
            return;
        }
        this.el.removeClass("aside-open");
        event.preventDefault();
        this.handleChange(event);
    };
    SearchFilter.prototype.handleClear = function (event) {
        if (!hasPushState) {
            return;
        }
        if (this.lastRequest) {
            this.lastRequest.abort();
            this.cleanupRequest();
        }
        if (event) {
            event.preventDefault();
        }
        if (this.initialState) {
            history.pushState(this.initialState, "", this.initialState.url);
            SearchFilter.replaceContent(this.initialState);
        }
        else {
            $doc.find("form.search-filter").addClass("updating");
            this.ajaxSubmit(this.initialStatePath);
        }
    };
    SearchFilter.prototype.handleChange = function (event) {
        if (this.lastRequest) {
            this.lastRequest.abort();
            this.cleanupRequest();
        }
        if (event && (0, jquery_1.default)(event.target).hasClass("cancel-autosubmit")) {
            return;
        }
        if (!hasPushState && document.body.clientWidth > 640) {
            this.autoSubmit();
        }
        else if (hasPushState) {
            this.ajaxSubmit();
        }
    };
    SearchFilter.handlePopstate = function () {
        SearchFilter.replaceContent(history.state);
    };
    SearchFilter.prototype.ajaxSubmit = function (url) {
        var form = $doc.find("form.search-filter");
        var getString = form.serialize();
        var action = form.attr("action");
        $doc.find(".search-results").addClass("updating");
        this.lastUrl = url || [action, getString].join("?");
        this.lastRequest = jquery_1.default
            .ajax({
            url: this.lastUrl,
            method: "GET",
            context: this,
            xhr: function () {
                var xhr = jquery_1.default.ajaxSettings.xhr();
                var setRequestHeader = xhr.setRequestHeader;
                xhr.setRequestHeader = function (name, value) {
                    if (name == "X-Requested-With") {
                        return;
                    }
                    if (setRequestHeader) {
                        setRequestHeader.call(xhr, name, value);
                    }
                };
                return xhr;
            }
        })
            .done(this.handleRequestDone)
            .always(this.cleanupRequest);
    };
    SearchFilter.prototype.autoSubmit = function () {
        var form = $doc.find("form.search-filter");
        clearTimeout(this.debounceID);
        this.debounceID = setTimeout(function () {
            form.submit();
        }, this.config.debounceTime);
    };
    SearchFilter.prototype.cleanupRequest = function () {
        this.lastRequest = null;
        this.lastUrl = null;
        $doc.find(".search-results").removeClass("updating");
        $doc.find("form.search-filter").removeClass("updating");
    };
    SearchFilter.prototype.handleRequestDone = function (fragment) {
        var state = SearchFilter.getState(fragment, this.lastUrl);
        if (this.lastUrl == this.initialStatePath) {
            this.initialState = state;
        }
        history.pushState(state, "", this.lastUrl);
        SearchFilter.replaceContent(state);
    };
    SearchFilter.getState = function (documentString, url) {
        var $newDoc = (0, jquery_1.default)(documentString);
        var results = (0, jquery_1.default)("<div />");
        $newDoc.find(".search-results").appendTo(results);
        return {
            results: results.html(),
            filters: SearchFilter.getContentHtml($newDoc, ".filters"),
            meta: SearchFilter.getContentHtml($newDoc, ".search-meta"),
            search: SearchFilter.getContentHtml($newDoc, ".search-bar"),
            title: SearchFilter.getContentHtml($newDoc, "title"),
            url: url
        };
    };
    SearchFilter.getContentHtml = function ($doc, selector) {
        return $doc.filter(selector).html() || $doc.find(selector).html();
    };
    SearchFilter.replaceContent = function (state) {
        $doc.find(".search-results").replaceWith(state.results);
        $doc.find("title").html(state.title);
        SearchFilter.replaceContentOrHide($doc.find(".filters"), state.filters);
        SearchFilter.replaceContentOrHide($doc.find(".search-meta"), state.meta);
        SearchFilter.replaceContentOrHide($doc.find(".search-bar"), state.search);
        SearchFilter.applyWidgets();
        PageLoader_1.PageLoader.getBus().notify(PageLoader_1.PAGE_LOADER_EVENTS.CONTENT_UPDATED);
    };
    SearchFilter.replaceContentOrHide = function (section, replacement) {
        if (replacement) {
            section.html(replacement);
        }
        else {
            section.hide();
        }
    };
    SearchFilter.applyWidgets = function () {
        PageLoader_1.PageLoader.each(".search-results");
        Collapsible_1.Collapsible.each(".filter.collapsible");
    };
    return SearchFilter;
}(Widget_1.Widget));
exports.SearchFilter = SearchFilter;
